<template>
  <div class="phone-login">
    <div class="ipt-group" :class="{error: $v.form.phone.$error}">
      <input type="text" autocomplete="off" v-model.trim="form.phone">
      <p class="sub-text" :class="{'has-text': form.phone}" @click="focusInput">手机号</p>
      <div class="line" :style="'background:'+$store.state.theme.themeColor"></div>
      <vd-tips path="form.phone" class="error-tip"/>
    </div>
    <div class="code-container">
      <div class="ipt-group mb60 code-group" :class="{error: $v.form.code.$error}">
        <input type="text" v-model.trim="form.code">
        <p class="sub-text" :class="{'has-text': form.code}" @click="focusInput">验证码</p>
        <div class="line" :style="'background:'+$store.state.theme.themeColor"></div>
        <vd-tips path="form.code" class="error-tip"/>
      </div>
      <countdown-btn
        class="code-btn"
        el="button"
        ref="loginCapchaBtn"
        :style="'background: '+$store.state.theme.themeSubColor+'color: '+$store.state.theme.themeColor"
        placeholder="获取验证码"
        lockTmp="%s秒后重新发送"
        @click="getCode"
        clickTips="正在获取验证码"></countdown-btn>
    </div>
    <countdown-btn el="button" type="submit" class="login-btn"
      :style="'background:' + theme.buttonBackground + 'box-shadow: ' + theme.buttonShadow" placeholder="登录"
      lockTmp="登录中..." clickTips="请稍后" @click="phoneLogin"></countdown-btn>
  </div>
</template>

<script>
import { required, validationMixin, phone } from '@/utils/mixin_validate'
import CountdownBtn from '@/components/CountdownBtn'
import { mapState } from 'vuex'

export default {
  components: {
    CountdownBtn
  },
  mixins: [validationMixin()],
  validations() {
    // 定义检验规则时注意顺序，弹窗模式时将按顺序弹窗
    return {
      form: {
        phone: {
          required,
          phone
        },
        code: {
          required
        }
      }
    }
  },
  validators: {
    // 这里定义错误提示，与validations结构一一对应
    form: {
      phone: {
        required: '请输入正确的手机号',
        phone: '请输入正确的手机号'
      },
      code: {
        required: '请输入验证码'
      }
    }
  },
  computed: {
    ...mapState([
      'captchaCb'
    ]),
    theme() {
      return this.$store.state.theme
    }
  },
  watch: {
    captchaCb (newVal, oldVal) {
      const countdownBtn = this.$refs.loginCapchaBtn
      if (newVal === 'lock') {
        countdownBtn.lock()
      } else if (newVal === 'reset') {
        countdownBtn.reset()
      }
    }
  },
  data () {
    return {
      form: {
        phone: '',
        code: ''
      }
    }
  },
  methods: {
    focusInput(e) {
      e.target.previousSibling.focus()
    },
    async getCode (lock, reset) {
      this.$v.form.phone.$touch()
      const tip = this._getValidatorError(this.$v.form.phone)
      if (tip.tips !== '未知错误') {
        reset()
        return
      }
      this.$store.commit('SETSTATE', [
        { key: 'captchaType', value: 'login_captcha' },
        { key: 'phoneNum', value: this.form.phone }
      ])
      try {
        lock()
        await this.$store.dispatch('getCaptchaInit', 'egLIJPgY')
        this.$store.state.captcha.show()
      } catch (e) {
        reset()
      }
    },
    // 手机验证码登录
    async phoneLogin(lock, reset) {
      this.validationTouch()
      const { phone, code } = this.form
      try {
        lock()
        await this.$auth('login_phone', ...[phone, code])
        localStorage.setItem('currentAccount', '')
        this.$emit('success')
        reset()
      } catch (e) {
        this.$emit('fail', e)
        reset()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.phone-login {
  @import './index.scss';
}

.code-container {
  position: relative;
  .code-btn {
    cursor: pointer;
    width: 130px;
    height: 42px;
    position: absolute;
    top: 23px;
    right: 0;
    background: $themeSubColor;
    border-radius: 4px;
    color: $themeColor;
    font-size: 14px;
    font-weight: 300;
    &.clicked,
    &.locked,
    &.disabled {
      cursor: default !important;
      color: #fff !important;
    }
  }
}
</style>
